import { render } from "./NotificationBadge.vue?vue&type=template&id=347ab566&scoped=true"
import script from "./NotificationBadge.vue?vue&type=script&lang=js"
export * from "./NotificationBadge.vue?vue&type=script&lang=js"

import "./NotificationBadge.vue?vue&type=style&index=0&id=347ab566&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347ab566"]])

export default __exports__